import { v4 as uuidV4 } from 'uuid';
import type { Clothes } from 'contracts/Clothes';

import cima01 from 'assets/images/products/cima_01.jpg';
import cima02 from 'assets/images/products/cima_02.jpg';
import cima03 from 'assets/images/products/cima_03.jpg';
import cima04 from 'assets/images/products/cima_04.jpg';

export const clothes: Clothes[] = [
  {
    id: uuidV4(),
    name: 'Jaqueta de pelúcia',
    image: cima01,
    price: 'R$ 173,20',
    url: 'https://produto.mercadolivre.com.br/MLB-1719578330-mulheres-com-capuz-de-pelucia-quente-jaquetas-zipper-cardiga-_JM?searchVariation=68299848908#searchVariation=68299848908&position=23&search_layout=grid&type=item&tracking_id=d9c2ffb0-30d1-4841-9aa1-886955316728',
  },
  {
    id: uuidV4(),
    name: 'Cropped de gola alta',
    image: cima02,
    price: 'R$ 31,25',
    url: 'https://produto.mercadolivre.com.br/MLB-1966560946-croped-gola-alta-manga-longa-promoco-_JM?searchVariation=92804449614#searchVariation=92804449614&position=3&search_layout=grid&type=item&tracking_id=c1f78766-6ba9-4379-8a89-a8b979fd5970',
  },
  {
    id: uuidV4(),
    name: 'Camiseta rosa',
    image: cima03,
    price: 'R$ 67,90',
    url: 'https://produto.mercadolivre.com.br/MLB-1313587107-justin-bieber-drew-house-mascot-camiseta-100-algodo-_JM?searchVariation=173763063964#searchVariation=173763063964&position=32&search_layout=grid&type=item&tracking_id=b9781cc2-bb62-4a59-9313-f3201489e951',
  },
  {
    id: uuidV4(),
    name: 'Jaqueta branca',
    image: cima04,
    price: 'R$ 1.250',
    url: 'https://produto.mercadolivre.com.br/MLB-1526122339-jaqueta-de-couro-legitimo-feminina-perfecto-cropped-_JM?searchVariation=57534390063#searchVariation=57534390063&position=38&search_layout=grid&type=item&tracking_id=7806ef64-793f-4a7d-9991-ee9d43ba340f',
  },
];
